import {CustomTag, CustomTagsGateway} from "@livechat/tags";
import {UseCase} from "@livechat/shared";
import {Observable} from "rxjs";

export class FindTagUseCase implements UseCase<{ id: number }, Observable<CustomTag>> {
  constructor(private tagsGateway: CustomTagsGateway) {
  }

  execute(params: { id: number }): Observable<CustomTag> {
    return this.tagsGateway.find(params.id)
  }
}
